import { computed, defineComponent } from 'vue'
import styles from './index.module.scss'

export default defineComponent({
  name: 'MkTips',
  props: {
    tips: {
      type: String,
      default: '该页面仅为预览，数据不会进行统计',
    },
    status: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const txt = computed(() => {
      if (![0, 2].includes(props.status))
        return props.tips

      let t = '该素材仅供预览'
      if (props.status === 2)
        t = '该素材已下线，仅供预览'

      if (props.status === 0)
        t = '该素材是草稿，仅供预览'

      return t
    })
    return () => (
      <div class={`${styles['mk-tips']} mk-bg-primary-10 mk-text-primary flex-s mk-fs-12`}>{txt.value}</div>
    )
  },
})
